import { render, staticRenderFns } from "./BullTableThree.vue?vue&type=template&id=06c4bff9&scoped=true&"
import script from "./BullTableThree.vue?vue&type=script&lang=js&"
export * from "./BullTableThree.vue?vue&type=script&lang=js&"
import style0 from "./BullTableThree.vue?vue&type=style&index=0&id=06c4bff9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06c4bff9",
  null
  
)

export default component.exports